var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"gl-block gl-h-2 gl-w-5 gl-rounded-sm",style:(_vm.pillStyle),attrs:{"role":"status","aria-label":_vm.ariaLabel}})
}
var staticRenderFns = []

export { render, staticRenderFns }